
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'SkyBrightness',
  props: {
    skyBrightness: {
      type: String,
      required: true,
    },
  },
  computed: {
    getSkyBrightness():string {
      return `${this.skyBrightness} mag/arcsec\u00B2`;
    },
  },
});
